import request2 from '@/utils/request2';
import {decrypt} from "@/utils/crypto";

// 代理商登录
export function login(query) {
  return request2({
    url: `/login`,
    method: 'post',
    params: query,
  });
}
// 手机号免密登录：小程序免登录跳 H5 专用，后端只校验手机号是否存在于 xt_user，不校验密码
export function loginByMobile(query) {
  return request2({
    url: `/wx/loginByMobile`,
    method: 'post',
    params: query,
  });
}
export function getOperatorSelect(params) {
  return request2({
    url: `/operator/getOperatorSelect`,
    method: 'get',
    params: params,
  });
}
//订单列表
export function getOrderList(query) {
  return request2({
    url: '/sysOrder/getOrderList',
    method: 'get',
    params: query,
  });
}
//订单详情
export function getOrderDetails(query) {
  return request2({
    url: '/sysOrder/getOrderData',
    method: 'get',
    params: query,
  });
}
//订单详情2
export function getOrderDetails2(query) {
  return request2({
    url: '/sysOrder/v2/order-detail',
    method: 'get',
    params: query,
  });
}
//订单状态追踪
export function getOrderTrack(query) {
  return request2({
    url: '/sysOrder/v2/order-trace',
    method: 'get',
    params: query,
  });
}
//获取站点列表
export function getPlotList(query) {
  return request2({
    url: '/plot/getPlotList',
    method: 'get',
    params: query,
  });
}
//新增站点
export function addPlot(body) {
  return request2({
    url: '/plot/addPlot',
    method: 'post',
    data: body,
  });
}

//删除站点
export function deletePlot(query) {
  return request2({
    url: `/plot/delPlot?id=${query.id}`,
    method: 'delete',
  });
}
//编辑站点
export function editPlot(body) {
  return request2({
    url: `/plot/editPlot`,
    method: 'post',
    data: body,
  });
}
//获取广告列表
export function getAdvertList(query) {
  return request2({
    url: `/advert/getAdvertList`,
    method: 'get',
    params: query,
  });
}
//新增广告
export function addAdvertList(body) {
  return request2({
    url: `/advert/addAdvert`,
    method: 'post',
    data: body,
  });
}
//删除广告
export function delAdvert(query) {
  return request2({
    url: `/advert/delAdvert`,
    method: 'delete',
    params: query,
  });
}
//编辑广告
export function editAdvert(body) {
  return request2({
    url: `/advert/edit`,
    method: 'put',
    data: body,
  });
}
//获取促销列表
export function getPromotionList(query) {
  return request2({
    url: `/promotion/getPromotionList`,
    method: 'get',
    params: query,
  });
}
//添加促销
export function addPromotion(body) {
  return request2({
    url: `/promotion/addPromotion`,
    method: 'post',
    data: body,
  });
}
//更新促销
export function upDatePromotion(body) {
  return request2({
    url: `/promotion/updatePromotion`,
    method: 'post',
    data: body,
  });
}
//删除促销
export function delPromotion(id) {
  return request2({
    url: `/promotion/delPromotion?id=${id}`,
    method: 'delete',
  });
}

export function getChargeTotal(data) {
  return request2({
    url: '/chargingpile/getChargeTotal',
    method: 'post',
    data: data,
  });
}

//新增设备
export function addEquip(body) {
  return request2({
    url: `/chargingpile/addPile`,
    method: 'post',
    data: body,
  });
}
//编辑设备
export function editPile(body) {
  return request2({
    url: `/chargingpile/editPile`,
    method: 'post',
    data: body,
  });
}

//获取设备列表
export function getEquipList(query) {
  return request2({
    url: `/chargingpile/getChargingPileList`,
    method: 'get',
    params: query,
  });
}
//获取菜单列表
export function getMenuList(data) {
  return request2({
    url: `/menu/getMenuList`,
    method: 'get',
    params: data,
  });
}

//获取用户数据列表
export function getUserList(data) {
  return request2({
    url: `/registerUser/getRegisterUser`,
    method: 'get',
    params: data,
  });
}
// 获取用户充值记录
export function getUserChongzhi(data) {
  return request2({
    url: `/registerUser/getRechargeRecods`,
    method: 'get',
    params: data,
  });
}

// 获取卡列表
export function getCardList(data) {
  return request2({
    url: `/sysCard/getCardList`,
    method: 'get',
    params: data,
  });
}
//查询注册用户下所有的未挂失的卡
export function getCardListByCustomerId(data) {
  return request2({
    url: `/sysCard/getCardListByCustomerId`,
    method: 'get',
    params: data,
  });
}
// 转账
export function transferAccounts(body) {
  return request2({
    url: `/sysCard/transferAccounts`,
    method: 'post',
    params: body,
  });
}

// 挂失卡
export function lossCard(query) {
  return request2({
    url: `/sysCard/lossCard`,
    method: 'get',
    params: query,
  });
}

//删除卡
export function delCards(query) {
  return request2({
    url: `/sysCard/delCards`,
    method: 'delete',
    params: query,
  });
}

//充值卡
export function chongzhiCard(body) {
  return request2({
    url: `/sysCard/rechargeCard`,
    method: 'post',
    params: body,
  });
}

//取消挂失
export function cancelLoss(body) {
  return request2({
    url: `/sysCard/cancelLoss`,
    method: 'get',
    params: body,
  });
}

//补卡
export function cardFeplacement(body) {
  return request2({
    url: `/card/cardFeplacement`,
    method: 'post',
    data: body,
  });
}

// 新增卡
export function addCard(data) {
  return request2({
    url: `/sysCard/addCard`,
    method: 'post',
    data: data,
  });
}
// 编辑卡
export function editCard(body) {
  return request2({
    url: `/card/editCard`,
    method: 'post',
    params: body,
  });
}
// 卡充值记录
export function getRechargeRecods(query) {
  return request2({
    url: `/sysCard/getRechargeRecords`,
    method: 'get',
    params: query,
  });
}
// 卡使用记录
export function getUseRecods(query) {
  return request2({
    url: `/sysCard/getUseRecods`,
    method: 'get',
    params: query,
  });
}
// 用户余额
export function getMyData(query) {
  return request2({
    url: `/my/getMyData`,
    method: 'get',
    params: query,
  });
}
//绑定提现wxGET
export function bindWx(code) {
  return request2({ url: `/my/bindWx?code=${code}`, method: 'get' });
}
//获取用户提现记录列表
export function getCashRecord(params) {
  return request2({
    url: `/my/getCashRecord`,
    method: 'get',
    params,
  });
}
// 获取用户信息
export function getUserInfo(query) {
  return request2({
    url: `/registerUser/userInfo`,
    method: 'get',
    params: query,
  });
}
// 获取今日收益
export function getDayProfit(query) {
  return request2({
    url: `/management/getDayProfit`,
    method: 'get',
    params: query,
  });
}
// 发送验证码
export function sendMsg(query) {
  return request2({
    url: `/my/sendMsg`,
    method: 'get',
    params: query,
  });
}
// 提现
export function cashWithdrawal(query) {
  return request2({
    url: `/my/cashWithdrawal`,
    method: 'get',
    params: query,
  });
}

// 获取规则时段
export function getRulePriceList(query) {
  return request2({
    url: '/rule/getRulePriceList',
    method: 'get',
    params: query,
  });
}
// 获取规则列表
export function getRuleList(data) {
  return request2({
    url: '/sysRule/getRuleList',
    method: 'get',
    params: data,
  });
}
// 编辑规则
export function editRule(data) {
  return request2({
    url: '/sysRule/v2/editRule',
    method: 'post',
    data: data,
  });
}
// 新增规则
export function addRule(data) {
  return request2({
    url: '/sysRule/v2/addRule',
    method: 'post',
    data: data,
  });
}
// 删除规则
export function deleteRule(data) {
  return request2({
    url: '/sysRule/deleteRule',
    method: 'delete',
    params: data,
  });
}
// 问题反馈列表
export function getFeedBackList(data) {
  return request2({
    url: '/sysFeedback/getFeedBackList',
    method: 'get',
    params: data,
  });
}
// 获取端口列表
export function getPortList(data) {
  return request2({
    url: '/port/getPortList',
    method: 'get',
    params: data,
  });
}
//设置充电桩规则
export function setPileRule(data) {
  return request2({
    url: '/chargingpile/setPileRule',
    method: 'get',
    params: data,
  });
}
// 开启关闭端口
export function switchPort(data) {
  return request2({
    url: '/port/switchPort',
    method: 'post',
    params: data,
  });
}
export function editPort(data) {
  return request2({
    url: '/port/editPort',
    method: 'post',
    data: data,
  });
}
//订单退款
export function refundOrder(data) {
  return request2({
    url: '/sysOrder/refundOrder',
    method: 'get',
    params: data,
  });
}
// 复制规则
export function copyRule(data) {
  return request2({
    url: '/sysRule/copyRule',
    method: 'get',
    params: data,
  });
}
// 密码修改
export function changePwd(data) {
  return request2({
    url: '/changePwd',
    method: 'post',
    data: data,
  });
}
// 登出
export function loginOut(data) {
  return request2({
    url: '/loginOut',
    method: 'post',
    data: data,
  });
}
//订单状态跟踪
export function orderTrace(data) {
  return request2({
    url: '/sysOrder/v2/order-trace',
    method: 'get',
    params: data,
  });
}
// 问题反馈详情
export function getFeedBack(data) {
  return request2({
    url: '/sysFeedback/getFeedBack',
    method: 'post',
    params: data,
  });
}
// 问题处理
export function doFeedBack(data) {
  return request2({
    url: '/sysFeedback/doFeedBack',
    method: 'get',
    params: data,
  });
}
// 充电桩收益
export function getSalesDetailByParams(data) {
  return request2({
    url: '/management/getSalesDetailByParams',
    method: 'get',
    params: data,
  });
}

export function getInfoByKey(data) {
  return request2({
    url: '/sysConfig/getInfoByKey',
    method: 'get',
    params: data,
  });
}

export function queryNewsByNewsConfigKey(data) {
  return request2({
    url: '/sysNews/queryNewsByNewsConfigKey',
    method: 'post',
    params: data,
  });
}

//本月收益
export function getMonProfit() {
  return request2({
    url: '/management/getMonProfit',
    method: 'get',
  });
}

export function getMapGeocoder(params) {
  return request2({
    url: '/qq/map/geocoder',
    method: 'get',
    params: params,
  });
}

export function getMapSuggestion(params) {
  return request2({
    url: '/qq/map/suggestion',
    method: 'get',
    params: params,
  });
}

// 获取分成汇总数据
export function getRoyaltySummary(params) {
  return request2({
    url: '/royalty/getRoyaltySummary',
    method: 'get',
    params: params,
  });
}

// 获取代理商、分成者的站点列表
export function getPlotListForOperator(query) {
  return request2({
    url: '/royalty/getPlotList',
    method: 'get',
    params: query,
  });
}

//获取网站配置
export async function getWebConfig(query) {
  let res = await request2({
        url: '/webConfig/getDefault',
        method: 'get',
        params: query,
    });
    if(decrypt(res.data) != null){
        res.data = decrypt(res.data);
    }
    return res;
}

//获取站点类型
export function getPlotTypeList(query) {
  return request2({
    url: '/getCodesByParent',
    method: 'get',
    params: query,
  });
}

//设置分成
export function setSharingType(query) {
  return request2({
    url: '/plot/setSharingType',
    method: 'post',
    data: query,
  });
}

//占桩费设置
export function addOccupancySettings(query) {
  return request2({
    url: '/occupancy/save',
    method: 'post',
    params: query,
  });
}

//获取账户详情
export function showaccount(params) {
  return request2({
    url: '/withdraworder/myAccount',
    method: 'get',
    params,
  });
}

//确认提现
export function applywithdraw(data) {
  return request2({
    url: '/trade/withdraw',
    method: 'post',
    data,
  });
}

//获取提现列表
export function withdrawindex(params) {
  return request2({
    url: '/sysOrder/withdraworder/getOrderList',
    method: 'get',
    params,
  });
}

//分成者查看分账明细
export function shareOrderGetList(params) {
  return request2({
    url: '/sysOrder/shareOrder/getOrderList',
    method: 'get',
    params,
  });
}

//清分代理商分成明细
export function getCommissionRecordListForOperator(params) {
  return request2({
    url: '/operatorCommissionRecord/getCommissionRecordListForOperator',
    method: 'get',
    params,
  });
}

//订单分成者分成明细
export function getShareholderRoyaltyResultList(params) {
  return request2({
    url: '/operatorCommissionRecord/getShareholderRoyaltyResultList',
    method: 'get',
    params,
  });
}

//分成者管理列表
export function getShareholderList(params) {
  return request2({
    url: '/v2/shareholders/action/page',
    method: 'get',
    params,
  });
}

//pc订单列表
export function getOrderList2(params) {
  return request2({
    url: '/chargingOrder/getOrderList',
    method: 'get',
    params,
  });
}

// pc订单详情
export function getListByOrderNo(data) {
  return request2({
    url: '/order/process/getListByOrderNo',
    method: 'post',
    data,
  });
}

//企业列表
export function getPageGroup(params) {
  return request2({
    url: '/group/pageGroup',
    method: 'get',
    params,
  });
}

// 场站总收益Top10
export function getStationRank() {
  return request2({
    url: '/largeScreen/stationRevenueRanking',
    method: 'get',
  });
}

//给团队充值
export function rechargeGroup(data) {
  return request2({
    url: '/group/rechargeGroup',
    method: 'post',
    params: data,
  });
}

//给团队扣款
export function deductionGroup(data) {
  return request2({
    url: '/group/deductionGroup',
    method: 'post',
    params: data,
  });
}

// 站点统计
export function getPlotStatiscs(params) {
  return request2({
    url: `/largeScreen/getPlotStatiscs`,
    method: 'get',
    params: params,
  });
}

// 获取设备状态
export function getDeviceStatiscs(params) {
  return request2({
    url: `/largeScreen/getDeviceStatiscs`,
    method: 'get',
    params: params,
  });
}

// 企业统计信息接口
export function getCountInfoByGroup(params) {
  return request2({
    url: `/group/getCountInfoByGroup`,
    method: 'get',
    params: params,
  });
}

// 车队统计信息接口
export function getCountInfoByCarTeam(params) {
  return request2({
    url: `/group/getCountInfoByCarTeam`,
    method: 'get',
    params: params,
  });
}

// 获取企业信息接口
export function getGroupInfo(params) {
  return request2({
    url: `/group/getGroupInfo`,
    method: 'get',
    params: params,
  });
}

// 获取车队信息接口
export function getCarTeamInfo(params) {
  return request2({
    url: `/group/getCarTeamInfo`,
    method: 'get',
    params: params,
  });
}

 // 获取当前用户的车队列表（负责人）
export  const pageGroupListCarTeam=(params) => request2.get('/group/listCarTeam',params)

  // 获取日历电量
export  const pageGroupChargingCalendar=(params) => request2.get('/group/chargingCalendar',params)

  // 分页查询车队账单
export  const transactionRecordPage=(params) => request2.get('/transactionRecord/pageTransactionRecordList',params)

  // 发送账单到邮箱
export  const exportExcelAndSendEmail=(params) => request2.post('/transactionRecord/h5/exportExcelAndSendEmail',params)

  // 订单列表分页
export  const orderFindOrderByCarTeam=(params) => request2.get('/chargingorder/findOrderByCarTeam',params)

  // 获取订单明细
export  const orderGetOrderByNumber=(params) => request2.get('/chargingorder/getOrderByNumber',params)

 // 分页查询司机列表
export  const groupPageGroupUser=(params) => request2.get('/group/pageGroupUser',params)

 // 查询司机详情
export  const groupGetGroupUserByUserId=(params) => request2.get('/group/getGroupUserByUserId',params)

  // 保存限额配置
export  const updateTeamBalanceSettings=(params) => request2.post('/group/updateTeamBalanceSettings',params)

 // 车辆列表
export  const listCarVinByTeamId=(params) => request2.get('/group/listCarVinByTeamId',params)

 // 车辆维护
export  const updateCarVin=(params) => request2.post('/group/updateCarVin',params)

 // 车辆列表
export  const cardInfo=(params) => request2.get('/card/info',params)

 // 检查是不是车队联系人
export  const isGroupContact=(params) => request2.get('/group/isGroupContact',params)

 // 获取微信config信息
export function getWxServiceConfig(params) {
  return request2({
    url: '/user/getWxServiceConfig',
    method: 'get',
    params,
  });
}


// 获取数电管理url
export function getEtaxUserUrl(data) {
    return request2({
        url: '/invoice/profile/getEtaxUserUrl',
        method: 'get',
        params: data
    })
}